module.exports = __webpack_public_path__ + "static/media/payment-error.84ebcc78.png";